<template>
  <div class="setting-list">
    <ul>
      <li
        v-for="(setting, index) in settings"
        :key="setting.title"
        :class="{ js_show: setting.expand }"
      >
        <template v-if="setting.items">
          <div
            class="weui-flex js_category"
            @click="setting.expand = !setting.expand"
          >
            <p class="weui-flex__item">{{ setting.title }}</p>
            <span class="js_category_icon" :class="setting.icon"></span>
          </div>
          <div class="page__category js_categoryInner">
            <div class="weui-cells page__category-content">
              <router-link
                class="weui-cell weui-cell_active weui-cell_access js_item"
                data-id="button"
                href="javascript:"
                v-for="item in setting.items"
                :key="item.title"
                :to="item.path"
              >
                <div class="weui-cell__bd">
                  <p>{{ item.title }}</p>
                </div>
                <div class="weui-cell__ft"></div>
              </router-link>
            </div>
          </div>
        </template>
        <template v-else>
          <a
            v-if="setting.url"
            :href="parseUrl(setting.url)"
            class="weui-flex js_category weui-cell_access"
          >
            <p class="weui-flex__item">{{ setting.title }}</p>
            <span class="js_category_icon" :class="setting.icon"></span>
          </a>
          <router-link
            v-else-if="setting.path"
            class="weui-flex js_category weui-cell_access"
            :to="setting.path"
          >
            <p class="weui-flex__item">{{ setting.title }}</p>
            <span class="js_category_icon" :class="setting.icon"></span>
          </router-link>
          <div v-else class="weui-flex js_category weui-cell_access" @click="onItemClick(index)">
            <p class="weui-flex__item">{{ setting.title }}</p>
            <span class="js_category_icon" :class="setting.icon"></span>
          </div>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
import Session from "@/util/session";

export default {
  props: {
    settings: Array,
  },
  methods: {
    parseUrl(url) {
      // 移动端从微信端自动登录，部分情况下没有cookie，需主动传jwtToken以识别身份
      if (url.indexOf("{jwtToken}") > 0) {
        return url.replace("{jwtToken}", Session.getToken());
      }
      return url;
    },
    onItemClick(index) {
      this.$emit('itemclick', this.settings[index]);
    }
  },
};
</script>

<style>
.setting-list ul li {
  margin: 8px 0;
  background-color: var(--weui-BG-2);
  overflow: hidden;
  border-radius: 2px;
  cursor: pointer;
}

.setting-list .js_category_icon {
  font-size: 24px;
  color: var(--weui-FG-1);
}

.setting-list .weui-flex__item {
  color: var(--weui-FG-1);
}

.setting-list ul li .js_categoryInner {
  display: none;
}

.setting-list ul li .js_categoryInner .weui-cells {
  margin-top: 0;
}

.setting-list ul li.js_show .js_category {
  opacity: 0.5;
}

.setting-list ul li.js_show .js_categoryInner {
  display: block;
}

.setting-list .weui-cell {
  padding-left: 20px;
  padding-right: 20px;
}

.setting-list .weui-flex {
  padding: 9px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
</style>